import {
  trigger,
  animate,
  transition,
  style,
  query,
  group,
  AnimationQueryMetadata,
  AnimationGroupMetadata,
  state
} from '@angular/animations';

/**
 * Fade animation
 */
export const fadeAnimation =
  trigger('fadeAnimation', [
    transition('* => *', [
      query(':enter',
        [
          style({opacity: 0})
        ],
        {optional: true}
      ),
      query(':leave',
        [
          animate('200ms ease-in', style({transform: 'translateY(-100%)'}))
        ],
        {optional: true}
      ),
      query(':enter',
        [
          style({transform: 'translateY(-100%)'}),
          animate('200ms ease-in', style({transform: 'translateY(0%)'}))
        ],
        {optional: true}
      )
    ])
  ]);

/**
 * Translate
 */
export const translate =
  trigger(
    'translate',
    [
      state('active' , style({ transform: 'translateY(80px)' })),
      state('inactive', style({ transform: 'translateY(0px)'  })),
      transition('active <=> inactive', animate('1000ms ease-in'))
    ]
  );

/**
 * Slow in out
 */
export const slowInOut =
  trigger(
    'slowInOut',
    [
      transition(
        ':enter',
        [
          style({opacity: 0}),
          animate('1200ms ease-in', style({opacity: 1}))
        ]
      ),
      transition(
        ':leave',
        [
          animate('400ms ease-in', style({opacity: 0}))
        ]
      )
    ]
  );

/**
 * In out
 */
export const inOut =
  trigger(
    'inOut',
    [
      transition(
        ':enter',
        [
          style({opacity: 0}),
          animate('800ms ease-in', style({opacity: 1}))
        ]
      ),
      transition(
        ':leave',
        [
          animate('300ms ease-in', style({opacity: 0}))
        ]
      )
    ]
  );

/**
 * Slide animation
 */
export const slider =
  trigger('slide', [
    transition('* => isLeft', slideTo('left')),
    transition('isLeft => isRight', slideTo('right')),
    transition('isRight => *', slideTo('left')),
    transition('isLeft => *', slideTo('right'))
  ]);


/**
 * Function for slide animation
 *
 * @param direction Direction string
 */
function slideTo(direction): [AnimationQueryMetadata, AnimationQueryMetadata, AnimationGroupMetadata] {
  const optional = {optional: true};
  return [
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        [direction]: 0,
        width: '100%'
      })
    ], optional),
    query(':enter', [
      style({[direction]: '-100%'})
    ]),
    group([
      query(':leave', [
        animate('200ms ease', style({[direction]: '80%'}))
      ], optional),
      query(':enter', [
        animate('600ms ease', style({[direction]: '0%'}))
      ])
    ])
  ];
}
